<template>  
    <section class="blockElement p-0 loginLoader" >  
        <div class="loginregister">
            <app-language :page="'login'"> </app-language> 
        </div> 
        <div class="container-fluid">
            <div class="riskWarningMsg d-md-none">
                <small>{{$t('lg_riskWarningMsg')}}</small>
            </div>
            <div class="innerInclude p_login"> 
                
                <div class="row"> 
                    
                    <div class="mobileLogo d-md-none">
						<router-link :to="'/'" class="green">
	                   		<img src="../../../../static/fxView/images/fxview_logo.svg" alt="fxView">
	                   	</router-link>
	                </div> 
					<div class="col-12 col-md-6 col-xl-4 text-center d-flex vh_100 flex-wrap blueBG beforeBG justify-content-center align-items-center ">
						<div class="w-100"> 
							<div class="titleArera Loginlogo">
								<router-link :to="'/'" class="green">
							   		<img src="../../../../static/fxView/images/fxview_logo_white.svg" alt="fxView">
								</router-link>
							</div>
							<div class="slider-sec">
								<div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
									<div class="carousel-inner">
									  <div class="carousel-item active">
										<div class="titleArera">
											<h2 class="medium mb-5">{{$t('fxMultiRegulated')}} <span class="bold d-block">{{$t('fxAwardWinningBroker')}}</span></h2>
										</div>
										<div class="award-sec d-flex flex-wrap justify-content-center">
											<div class="award-item text-center mb-4 pb-2">
												<img class="img-fluid mb-1"
													src="../../../../static/fxView/images/best2021.svg" />
												<h3 class="mb-1 text-white">{{ $t('fxBestValueBroker') }}</h3>
												<p class="m-0">{{ $t('fxForexExpo') }}<span class="d-block">{{ $t('fxDubai') }}</span></p>
											</div>

											<div class="award-item text-center mb-4 pb-2">
												<img class="img-fluid mb-1"
													src="../../../../static/fxView/images/most2022.svg" />
												<h3 class="mb-1 text-white">{{$t('fxMostTrustedBroker')}}</h3>
												<p class="m-0">{{$t('fxUltimateFintech')}}<span class="d-block">{{ $t('fxCyprus') }}</span>
												</p>
											</div>

											<div class="award-item text-center mb-4 pb-2">
												<img class="img-fluid mb-1"
													src="../../../../static/fxView/images/best-cfd-2022.svg" />
												<h3 class="mb-1 text-white">{{$t('fxBestGlobalCFDBroker')}}</h3>
												<p class="m-0">{{ $t('fxForexExpo') }}<span class="d-block">{{ $t('fxDubai') }}</span></p>
											</div>

											<div class="award-item text-center mb-4 pb-2">
												<img class="img-fluid mb-1"
													src="../../../../static/fxView/images/best-ecn-stp2023.svg" />
												<h3 class="mb-1 text-white">{{$t('fxBestECNSTPBroker')}}</h3>
												<p class="m-0">{{ $t('fxUFAwardsMEA') }}<span class="d-block">{{ $t('fxDubai') }}</span></p>
											</div>
											<div class="award-item text-center mb-4 pb-2">
												<img class="img-fluid mb-1"
													src="../../../../static/fxView/images/best-ecn-stp2023.svg" />
												<h3 class="mb-1 text-white">{{ $t('fxBestMultiAssetBroker') }}</h3>
												<p class="m-0">{{$t('fxFAME')}}<span class="d-block">{{ $t('fxSouthAfrica') }}</span></p>
											</div>
										</div>
									  </div>
									  <div class="carousel-item">
										<div class="loginNewSection  ">
											<div class="loginSpreads d-flex">
												<div class="d-flex position-relative InnerLogin">
													<div class="loginIcon">
														<figure>
															<img src="../../../../static/fxView/images/Spreads.png" alt="">  
														</figure>                                     
													</div>
													<div class="LoginContent  text-left" v-html="$t('reg_welcomemsg1')"></div>
												</div>
											</div>
											<div class="loginSpreads d-flex ">
												<div class="d-flex position-relative InnerLogin">
													<div class="loginIcon">
														<figure>
															<img src="../../../../static/fxView/images/Commission.png" alt="">  
														</figure>                                     
													</div>
													<div class="LoginContent text-right" v-html="$t('reg_welcomemsg2')"></div>
												</div>
											</div>
											<div class="loginSpreads d-flex">
												<div class="d-flex position-relative InnerLogin">
													<div class="loginIcon">
														<figure>
															<img src="../../../../static/fxView/images/TradingTools.png" alt="">  
														</figure>                                     
													</div>
													<div class="LoginContent text-left" v-html="$t('reg_welcomemsg3')"></div>
												</div>
											</div>
											<div class="loginSpreads d-flex ">
													<div class="d-flex position-relative InnerLogin">
													<div class="loginIcon">
														<figure>
															<img src="../../../../static/fxView/images/FastExecution.png" alt="">  
														</figure>                                     
													</div>
													<div class="LoginContent text-right" v-html="$t('reg_welcomemsg4')"></div>
												</div>
											</div>
											<div class="loginSpreads d-flex">
												<div class="d-flex position-relative InnerLogin">
													<div class="loginIcon">
														<figure>
															<img src="../../../../static/fxView/images/DepositBonus.png" alt="">  
														</figure>                                     
													</div>
													<div class="LoginContent text-left" v-html="$t('reg_welcomemsg5')"></div>
												</div>
											</div>
										</div>
									  </div>
									</div>
									<div class="clearfix"></div>
									<ol class="carousel-indicators">
										<li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
										<li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
									  </ol>
								  </div>
							</div>
						</div>
					</div>
                    <div class="col-12 col-md-6 col-xl-8 d-flex p-0 vh_100 align-items-center customHeight">
                        <div class="sign_insec">
                            <!--loader - message--->
                            <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
                            <div class="subtitle" v-if="!resend">
                                <h3 class="mb-3"> {{$t('lg_forgotPassword')}}</h3>
                                <p class="mb-3">{{$t('fp_forgotPasswordText')}} </p>
                                <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
                            </div>
                            <div class="mb-3 text-center" v-if="resend">
                                <img src="../../../../static/fxView/images/email_sent.svg" alt="email sent" width="60" class="mb-3">
                                <p>{{$t(response_msg)}}</p>    
                            </div>
							
                            <div class="stepForm"> 
                                <div class="form-group field-wrapper" v-if="!resend">
                                    <input   placeholder=" " type="text" name="email" v-model="email" class="float-field form-control"  v-validate="'required|email'"   :class="{ 'is-invalid': submitted && errors.has('email') }" ref="emailInput" />
                                    <label for="username" class="float-label">{{$t('lg_emailaddress')}} </label> 
                                    <ul><li v-for="error in errors.collect('email')">{{ error }}</li></ul>
                                </div> 
								<div class="row p-3" v-if="!submitted">
									<vue-recaptcha 
                                        class="captchaRegister"
                                        sitekey="6LcivBArAAAAADQ5sZSOf-5bbKHlE0pmqDxDt-ax" ref="recaptcha"
                                        @verify="onCaptchaVerified" @expired="onCaptchaExpired"
                                        size="visible"
                                    >
                                    </vue-recaptcha>
								</div>
                                <div class="clearfix"></div>
                                <div class="d-flex justify-content-between align-items-center submitButton">
                                    <button class="prism_btn btn_sm" v-on:click.prevent="submit()">
										<span v-if="!resend">{{$t('fp_resetPassword')}}</span> 
										<span v-if="resend">{{$t('fp_RESEND_EMAIL')}}</span> 
									</button>
                                    <div class="forgot_sec">
                                        <router-link :to="'/'" class="forgotpassword d-flex">
                                            <feather type="chevron-left" size="1rem" class="mr-1"></feather>{{$t('fp_backLogin')}}
                                        </router-link>     
                                    </div>
                                </div> 
                                
                                <div class="charlgateMsg border-top pt-2 mt-2">
                                    <small>{{$t('lg_charlgateMsGlobal')}}</small>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div> 
            </div>
        </div>
		<!-- <div class="fixedBarBottom fullwidth register-page-fixedbar">
            <div class="footPromoLastBar  text-center">
                <p class="" v-html="$t('footerMsz2')"></p>
                <a :href="legalDocLink" target="_blank">{{$t('riskDisclaimer')}}</a> 
            </div>
		</div> -->
    </section> 
</template>
<script>
    import * as types from '@/types'
    import { mapActions } from 'vuex'
    import { fxViewMixins } from '@/plugins/fxView'
	import language from '../shared/language_before_login'
	import VueRecaptcha from "vue-recaptcha";
    export default {
        name: 'Forgot-password',
        mixins: [fxViewMixins],
        data() {
            return {
                "email" : "",
				resend : false,
                submitted: false,
                pageLoader : false,
                response_msg : '',
                msg_type   : '', 
				captchaVerified: false,
                captchaToken: "",
                captachErr: false     
            }
        },
		components: {
            appLanguage: language,
			VueRecaptcha
        },
        methods:{
			onCaptchaVerified: function (recaptchaToken) {
                const self = this;
                this.captchaVerified = true;
                this.captchaToken = recaptchaToken;
            },

            onCaptchaExpired: function () {
                this.$refs.recaptcha.reset();
            },
            ...mapActions({
                _runUserForgotPassword: types.RUN_USER_FORGOT_PASSWORD
            }),
            submit(){
                const _that = this
                _that.$validator.validate().then(valid => {
					if (valid) {
						if (!this.captchaVerified) {
							_that.captachErr = true;
                            _that.submitted = false;
                        }else{ 
							_that.submitted = true;
							let input_json={
								'globalParams' :{
									"email": _that.email,
									'captchaToken': this.captchaToken,
								},
								'localParams' :{ "parameter" : _that }
							}
							_that._runUserForgotPassword(input_json)
						}
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/users/forgot_password.vue